module.exports = __webpack_public_path__ + "img/tank.f0da3841.png";